export const iconFontAwesomeCodingCodeMerge = (
	<i className="fa-solid fa-code-merge"></i>
);
